import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconTransmission: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 40 40" name="transmission">
    <path
      fillRule="evenodd"
      d="M17.735 13.333a3.333 3.333 0 0 0-3.334 3.334v1.666a3.333 3.333 0 0 0 3.334 3.334h5a3.333 3.333 0 0 0 3.333-3.334v-1.666a3.333 3.333 0 0 0-3.334-3.334h-1.667V10h-2v3.333h-1.332Zm5 2h-5c-.737 0-1.334.597-1.334 1.334v1.666c0 .737.597 1.334 1.334 1.334h5c.736 0 1.333-.597 1.333-1.334v-1.666c0-.737-.597-1.334-1.334-1.334Z"
      clipRule="evenodd"
    />
    <path d="M19.067 30v-8.333h2V30h-2ZM15.07 12.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16.07 23.333a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM15.07 29.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    <path
      fillRule="evenodd"
      d="M9.068 8.333A4.333 4.333 0 0 1 13.402 4h13.333a4.333 4.333 0 0 1 4.333 4.333v23.334A4.333 4.333 0 0 1 26.735 36H13.402a4.333 4.333 0 0 1-4.334-4.333V8.333ZM13.402 6a2.333 2.333 0 0 0-2.334 2.333v23.334A2.333 2.333 0 0 0 13.402 34h13.333a2.333 2.333 0 0 0 2.333-2.333V8.333A2.333 2.333 0 0 0 26.735 6H13.402Z"
      clipRule="evenodd"
    />
  </Icon>
);
